var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 col-xl-6"
  }, [_c('div', {
    staticClass: "font-weight-bold"
  }, [_vm._v(" 團購名稱：" + _vm._s(_vm.detailInfo.groupbuying_title) + " ")]), _c('div', {
    staticClass: "font-weight-bold"
  }, [_vm._v(" 團購編號：" + _vm._s(_vm.detailInfo.groupbuying_number) + " ")]), _c('div', [_vm._v("商品名稱：" + _vm._s(_vm.detailInfo.title))]), _c('div', [_vm._v("商品編號：" + _vm._s(_vm.detailInfo.product.sale_page_code))]), _c('div', [_vm._v("狀態：" + _vm._s(_vm.detailInfo.status))]), _c('div', [_vm._v("建立時間： " + _vm._s(_vm.detailInfo.created_at))]), _c('div', [_vm._v("開始時間： " + _vm._s(_vm.detailInfo.start_at))]), _c('div', [_vm._v("截止時間： " + _vm._s(_vm.detailInfo.end_at))])]), _c('div', {
    staticClass: "col-12 col-xl-6"
  }, [_c('div', [_vm._v(" 本團銷售：" + _vm._s(_vm.detailInfo.current_quantity || 0) + " ")]), _vm.detailInfo.type === _vm.GROUPBUYING_TYPE.SCAN ? _c('div', [_vm._v(" 本團分配庫存：" + _vm._s(_vm.detailInfo.max_quantity || 0) + " ")]) : _vm._e()])]);
}
var staticRenderFns = []

export { render, staticRenderFns }